import { z } from "zod";
import { answerSubCategorySchema } from "./answerSubCategory";

export const answerCategorySchema = z.object({
  data: z.object({
    id: z.number(),
    content: z.string(),
    is_answered: z.coerce.boolean(),
    answer_sub_categories: z.array(answerSubCategorySchema),
  }),
  prev: z.number().nullable(),
  next: z.number().nullable(),
});

export type AnswerCategory = z.infer<typeof answerCategorySchema>;
